<template>
  <div class="q-pa-md whidth">
    <div class="text-h6 q-mb-sm">Módulos Desativados</div>
    <q-table
      table-header-class="bg-accent text-weight-bold"
      :rows="modulosDesativos"
      :columns="columns"
      row-key="name"
      flat
      dense
      :rows-per-page-options="[0]"
      class="tabela-tamanho-fixo"
    >
      <template v-slot:body="props">
        <q-tr :props="props">
          <q-td class="text-left" key="nome" :props="props">{{
            props.row.nome
          }}</q-td>
          <q-td key="ativar" class="text-right">
            <q-btn
              color="white"
              text-color="green"
              round
              flat
              icon="add"
              @click="ativarModulo(props.row.moduloId)"
            />
          </q-td>
        </q-tr>
      </template>
    </q-table>
  </div>
</template>

<script>
import { useStore } from "vuex";

const columns = [
  {
    name: "nome",
    align: "left",
    label: "Nome Módulo",
    field: "NOME MODULO",
  },
  {
    name: "ativar",
    align: "right",
    label: "Ativar ",
    field: "NOME MODULO",
  },
];

export default {
  name: "DetalheCliente",
  props: ["modulosDesativos", "clienteId"],
  setup(props, { emit }) {
    const store = useStore();

    const ativarModulo = async (moduloId) => {
      try {
        await store.dispatch("office/vincularModulo", {
          clienteId: props.clienteId,
          moduloId,
        });

        emit("atualizarTabelas");
      } catch (error) {
        console.error(error);
      }
    };

    return { columns, ativarModulo };
  },
};
</script>

<style scoped>
.whidth {
  width: 40%;
}
</style>
